import { ONBOARDING_ACKNOWLEDGEMENTS } from "../data/onboardingAcknowledgements";
import { Card, CARD_TARGET_CLASS } from "./beui/SurfaceCard";
import { Checkbox } from "./beui/Checkbox";

export function OnboardingAcknowledgements({ checks, disabled, onChange }: {
  checks: Record<string, boolean>; disabled: boolean; onChange: (key: string, checked: boolean) => void;
}) {
  return <div className="space-y-3">{ONBOARDING_ACKNOWLEDGEMENTS.map(({ key, text }, index) =>
    <Card key={key} interactive={!disabled} selected={!!checks[key]} className="relative flex-row items-start gap-3 rounded-xl p-4">
      <span aria-hidden="true" className="pt-1 text-xs font-semibold tabular-nums text-mut">{String(index + 1).padStart(2, "0")}</span>
      <Checkbox checked={!!checks[key]} disabled={disabled} onCheckedChange={checked => onChange(key, checked)}
        label={text} className={`${CARD_TARGET_CLASS} min-w-0 flex-1 items-start gap-3 [&_button]:relative [&_button]:z-10 [&_button]:mt-0.5 [&_span]:leading-relaxed`} />
    </Card>
  )}</div>;
}
